// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__1qaW2","ltr":"Error_ltr__k-i4y"};